// extracted by mini-css-extract-plugin
export default {"sidebarTop":"SidebarTop_sidebarTop__7zeoB","logoContainer":"SidebarTop_logoContainer__Gf5rq","logo":"SidebarTop_logo__0j6vs","closeButton":"SidebarTop_closeButton__yigdP"};